<script>
  import Page from '@components/page.svelte'
  import Button from '@components/buttons/button.svelte'
  import Text from '@components/general/text.svelte'
  import OfferCard from '@components/offers/card.svelte'
  import CardPaymentCard from '@components/payment_methods/card-payment.svelte'
  import InvoicePaymentCard from '@components/payment_methods/invoice-payment.svelte'
  import InvoiceRequestForm from '@components/invoice_requests/form.svelte'
  import { Ticket } from 'lucide-svelte'
  import { cn, formatMoney } from '@lib/utils'
  import { toast } from 'svelte-sonner'
  import { router } from '@inertiajs/svelte'

  let { offers = [] } = $props()

  let offerId = $state(offers.length === 1 ? offers[0].id : null)
  let paymentMethod = $state(null)
  let checkoutLoading = $state(false)
  let invoiceRequestFormOpen = $state(false)

  let selectedOffer = $derived(offers.find(offer => offer.id === offerId))

  let multipleOffers = $derived(offers.length > 1)

  let showPaymentMethods = $derived(Boolean(selectedOffer))

  let pageProps = $derived({
    title: 'Unlock full access',
    subtitle: 'Get immediate unlimited access to all our videos, resources and live sessions.',
    icon: Ticket
  })

  function selectInvoiceMethod() {
    paymentMethod = 'invoice'
    invoiceRequestFormOpen = true
  }

  function redirectToStripe() {
    if (!selectedOffer) return
    checkoutLoading = true
    router.post('/memberships', { offer_id: selectedOffer.id }, {
      onError: () => {
        checkoutLoading = false
        toast.error('Something went wrong. Please try again.')
      }
    })
  }

</script>

<Page {...pageProps}>

  <!-- Wrap whole page in a max-width container -->
  <div class="flex flex-col items-start gap-12 pt-6 max-w-6xl">

    <!-- Offers section (normally only one) -->
    <section class="w-full">

      <Text variant="section_label" text="Choose an offer" class="mb-2" />

      <div class={cn(multipleOffers ? 'grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4' : '')}>
        {#each offers as offer}
          {@const selected = selectedOffer?.id === offer.id}
          <OfferCard {offer} {selected} onSelect={() => offerId = offer.id} />
        {/each}
      </div>

    </section>

    <!-- Payment method section -->
    {#if showPaymentMethods}
      <section class="w-full">

        <Text variant="section_label" text="Choose a payment method" class="mb-2" />

        <div class="flex gap-4 flex-wrap">
          <CardPaymentCard offer={selectedOffer} onSelect={redirectToStripe} loading={checkoutLoading} class="max-w-sm" />
          <InvoicePaymentCard onSelect={selectInvoiceMethod} class="max-w-sm" />
        </div>

      </section>
    {/if}

  </div>

</Page>

<InvoiceRequestForm
  bind:open={invoiceRequestFormOpen}
  offer={selectedOffer}
  onClose={() => invoiceRequestFormOpen = false}
  />
